import React, { useState, useEffect, useRef } from "react";
import { Card, Input, Switch, Dropdown, message, Modal, Button } from 'antd'
import { Circular, Line } from "../index";
import { CaretDownOutlined, GlobalOutlined, LeftOutlined, AlertOutlined } from '@ant-design/icons';
import AMapLoader from '@amap/amap-jsapi-loader';
import { useNavigate } from 'react-router-dom'
import { useTranslation, Trans } from 'react-i18next';
import { getCarNum, getOnlineCars, setPowerOff, getVehicleDistribution, getCarInfo, getCarInfo1, createFalconCircleFence } from "../../API/monitor";
import { bd09togcj02} from "../../utils/convert"
import './mointor.scss'
const { Search } = Input;


const Mointor = ({ setLng }) => {

    const navigate = useNavigate()

    const { t, i18n } = useTranslation();

    const [today, setToday] = useState("")

    const [weekly, setWeekly] = useState({
        inventoryVehiclesCount: [],
        rentedVehiclesCount: [],
        todayOnlineCount: [],
    })

    const mapRef = useRef(null);
    const markersRef = useRef([]);
    const timeoutRef = useRef(null);
    const selectedMarkerRef = useRef(null);
    const lastMarkerClickAtRef = useRef(0);
    const amapRef = useRef(null);

    const [searchValue, setSearchValue] = useState()

    const [switchValue, setSwitchValue] = useState(false)

    const [isModalOpen, setIsModalOpen] = useState(false);

    const [flag, setFlag] = useState(false)

    let timeout = null

    const [carInfo, setCarInfo] = useState("")

    const [tenant, setTenant] = useState("")

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    };

    const [carList, setCarList] = useState([])

    const [isRightFullscreen, setIsRightFullscreen] = useState(false);

    // 高德猎鹰电子围栏配置（圆形围栏）
    const FALCON_KEY = '8bda44bbc47f6ac989ebdeef9d715e9f';   // 高德 Web服务API Key（猎鹰接口需 Web服务类型 Key）
    const FALCON_SID = '';                                   // 猎鹰服务唯一编号（在高德控制台猎鹰服务创建后填入）
    const FENCE_NAME = 'lease_vehicle_fence';                // 围栏名称（同一 sid 下不可重复）
    const FENCE_CENTER = [79.8837996, 6.9332843];            // 围栏中心 [经度, 纬度]
    const FENCE_RADIUS = 10000;                                // 围栏半径（米），取值范围 [1, 50000]
    const fenceCreatedRef = useRef(false);
    const [alarmList, setAlarmList] = useState([]);
    const [isFenceAlarm, setIsFenceAlarm] = useState(false);
    const alarmRef = useRef({});
    const checkFenceAlarmRef = useRef(null);
    const selectMarkerRef = useRef(null);

    const createTricycleIcon = (AMap, status) => {
        const color = status === t('status.idle') ? 'green' : 'red';
        return new AMap.Icon({
            image: `${process.env.PUBLIC_URL + '/logo/tricycle.png'}`,
            size: new AMap.Size(40, 40)
        });
    };

    const toggleRightFullscreen = () => {
        setIsRightFullscreen(!isRightFullscreen);
    };

    useEffect(() => {
        AMapLoader.load({
            key: '8dc592afaea1afb7339514cc11218514',
            version: '2.0',
            plugins: ['AMap.Scale', 'AMap.ToolBar', "AMap.MoveAnimation"]
        }).then((AMap) => {
            const map = new AMap.Map('container', {
                viewMode: '2D',
                zoom: 11,
                center: carList?.length > 0 ? bd09togcj02(carList[0]?.longitude || 0, carList[0]?.latitude || 0) : FENCE_CENTER
            });

            let selectedMarker = null;
            mapRef.current = map;
            markersRef.current = [];
            amapRef.current = AMap;

            // 在地图上绘制猎鹰圆形电子围栏
            const fenceCircle = new AMap.Circle({
                center: FENCE_CENTER,
                radius: FENCE_RADIUS,
                fillColor: 'rgba(255, 0, 0, 0.1)',
                strokeColor: '#ff0000',
                strokeWeight: 2,
                strokeStyle: 'dashed'
            });
            map.add(fenceCircle);

            // 判断坐标是否在圆形围栏内（球面距离，单位米）
            const isPointInCircle = (longitude, latitude) => {
                const R = 6371000; // 地球平均半径（米）
                const rad = Math.PI / 180;
                const dLat = (latitude - FENCE_CENTER[1]) * rad;
                const dLng = (longitude - FENCE_CENTER[0]) * rad;
                const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                    Math.cos(FENCE_CENTER[1] * rad) * Math.cos(latitude * rad) *
                    Math.sin(dLng / 2) * Math.sin(dLng / 2);
                const distance = R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
                return distance <= FENCE_RADIUS;
            };

            const checkFenceAlarm = (carNumber, longitude, latitude) => {
                if (!longitude || !latitude) return;
                const isInside = isPointInCircle(Number(longitude), Number(latitude));
                if (!isInside && !alarmRef.current[carNumber]) {
                    alarmRef.current[carNumber] = true;
                    const alarmMsg = t('fence.alarm', { carNumber });
                    setIsFenceAlarm(true);
                    setAlarmList(prev => [{
                        carNumber,
                        time: new Date().toLocaleString(),
                        message: alarmMsg,
                        type: t('fence.type')
                    }, ...prev].slice(0, 10));
                } else if (isInside && alarmRef.current[carNumber]) {
                    alarmRef.current[carNumber] = false;
                }
            };

            checkFenceAlarmRef.current = checkFenceAlarm;

            // 通过高德猎鹰轨迹服务创建圆形电子围栏（每次页面加载只调用一次）
            if (!fenceCreatedRef.current) {
                fenceCreatedRef.current = true;
                if (FALCON_SID) {
                    createFalconCircleFence({
                        key: FALCON_KEY,
                        sid: FALCON_SID,
                        name: FENCE_NAME,
                        desc: FENCE_NAME,
                        center: `${FENCE_CENTER[0]},${FENCE_CENTER[1]}`,
                        radius: FENCE_RADIUS
                    }).then(res => {
                        const data = res?.data;
                        if (data?.errcode === 0) {
                            console.log('猎鹰围栏创建成功，gfido:', data?.data?.gfido);
                        } else {
                            console.log('猎鹰围栏创建返回异常:', data?.errcode, data?.errmsg);
                        }
                    }).catch(e => {
                        console.log('猎鹰围栏创建请求失败(可能浏览器跨域，需改为后端代理调用):', e?.message);
                    });
                } else {
                    console.log('未配置 FALCON_SID，跳过猎鹰围栏创建（地图上仍显示本地圆形围栏）');
                }
            }

            const markerLabelContent = (vehicle) => {
                const text = vehicle?.carNumber ?? vehicle?.vehicleNo ?? vehicle?.id ?? ''
                if (!text) return ''
                return `<div class="car-marker-label">${String(text)}</div>`
            }

            const getPixelXY = (pixel) => {
                const x = typeof pixel?.getX === 'function' ? pixel.getX() : pixel?.x
                const y = typeof pixel?.getY === 'function' ? pixel.getY() : pixel?.y
                return { x: Number(x), y: Number(y) }
            }

            const selectMarker = (marker, vehicle) => {
                if (!marker || !vehicle) return
                lastMarkerClickAtRef.current = Date.now()
                if (window.innerWidth <= 768) {
                    toggleRightFullscreen();
                }

                // 立即使用 marker 当前位置居中（marker 已在地图的正确 GCJ02 坐标上）
                const markerPos = marker.getPosition();
                mapRef.current.setCenter(markerPos);
                mapRef.current.setZoom(18);

                getCarInfo(vehicle?.carNumber).then(res => {
                    if (!mapRef.current) return;
                    setSearchValue(selectedMarkerRef?.current?._originOpts?.vehicleData?.carNumber)
                    if (res?.data?.code === 200) {
                        setCarInfo(res.data.data)
                        let latitude = res.data.data.latitude
                        let longitude = res.data.data.longitude
                        // 校验坐标有效性后再转换和居中
                        if (Number.isFinite(Number(longitude)) && Number.isFinite(Number(latitude))) {
                            const [gcjLng, gcjLat] = bd09togcj02(longitude, latitude);
                            mapRef.current.setCenter([gcjLng, gcjLat]);
                        }
                    } else {
                        message.error(res?.data?.msg)
                    }
                })
                getCarInfo1(vehicle?.carNumber).then(res => {
                    if (res?.data?.code === 200) {
                        const rows = res.data?.rows
                        if (Array.isArray(rows) && rows.length > 0) {
                            setTenant(rows[rows.length - 1])
                        } else {
                            setTenant("")
                        }
                    } else {
                        message.error(res?.data?.msg)
                    }
                })

                if (selectedMarkerRef.current && selectedMarkerRef.current !== marker) {
                    selectedMarkerRef.current.setIcon(createTricycleIcon(AMap, '普通'));
                    const lastAngle = selectedMarkerRef.current.getAngle();
                    selectedMarkerRef.current.setAngle(lastAngle);
                }

                selectedMarkerRef.current = marker;
                const initialAngle = marker.getAngle() || 0;
                marker.setIcon(createSelectedTricycleIcon(AMap, carInfo.status));
                marker.setAngle(initialAngle);

                const animationState = {
                    isAnimating: false,
                    targetPosition: null,
                    startPosition: null,
                    startTime: 0,
                    animationId: null
                };

                if (marker.animationState) {
                    cancelAnimationFrame(marker.animationState.animationId);
                }

                marker.animationState = animationState;

                if (timeoutRef.current) {
                    clearInterval(timeoutRef.current);
                    timeoutRef.current = null;
                }

                timeoutRef.current = setInterval(() => {
                    if (!mapRef.current) return;
                    getCarInfo(selectedMarkerRef?.current?._originOpts?.vehicleData?.carNumber).then(res => {
                        if (!mapRef.current) return;
                        if (res?.data?.code === 200) {
                            setCarInfo(res.data.data)
                            let longitude = res.data.data?.longitude
                            let latitude = res.data.data?.latitude
                            if (checkFenceAlarmRef.current) {
                                checkFenceAlarmRef.current(selectedMarkerRef?.current?._originOpts?.vehicleData?.carNumber, longitude, latitude);
                            }
                            if (res.data.data.currentVehicleSpeed != 0) {
                                if (animationState.isAnimating) {
                                    cancelAnimationFrame(animationState.animationId);
                                }

                                const targetPos = bd09togcj02(longitude || 0, latitude || 0);
                                const currentPos = marker.getPosition();

                                const lngDiff = Math.abs(currentPos.getLng() - targetPos[0]);
                                const latDiff = Math.abs(currentPos.getLat() - targetPos[1]);

                                if (lngDiff > 0.00001 || latDiff > 0.00001) {
                                    const newAngle = calculateDirectionAngle(
                                        currentPos.getLng(),
                                        currentPos.getLat(),
                                        targetPos[0],
                                        targetPos[1]
                                    );

                                    animationState.startPosition = currentPos;
                                    animationState.targetPosition = targetPos;
                                    animationState.startTime = Date.now();
                                    animationState.isAnimating = true;

                                    marker.setAngle(newAngle);
                                    animateMarker(marker, animationState);
                                }
                            }
                        } else {
                            message.error(res?.data?.msg)
                        }
                    })
                }, 5000);
            }
            selectMarkerRef.current = selectMarker;

            carList.forEach(vehicle => {
                const marker = new AMap.Marker({
                    position: bd09togcj02(vehicle?.longitude || 0, vehicle?.latitude || 0),
                    icon: createTricycleIcon(AMap),
                    map: map,
                    vehicleData: vehicle,
                    topWhenClick: true
                });

                const labelContent = markerLabelContent(vehicle)
                if (labelContent) {
                    marker.setLabel({
                        content: labelContent,
                        direction: 'top',
                        offset: new AMap.Pixel(0, -32)
                    })
                }

                marker.on('click', () => {
                    selectMarker(marker, vehicle)
                });
                markersRef.current.push(marker);

                if (vehicle?.longitude && vehicle?.latitude) {
                    checkFenceAlarm(vehicle.carNumber, vehicle.longitude, vehicle.latitude);
                }
            });

            map.on('click', (e) => {
                if (!e?.lnglat) return
                if (Date.now() - lastMarkerClickAtRef.current < 200) return
                if (!markersRef.current?.length) return
                const clickPixel = map.lngLatToContainer(e.lnglat)
                const { x: cx, y: cy } = getPixelXY(clickPixel)
                if (!Number.isFinite(cx) || !Number.isFinite(cy)) return
                let nearestMarker = null
                let nearestVehicle = null
                let minDist = Infinity
                for (const m of markersRef.current) {
                    const pos = m?.getPosition?.()
                    if (!pos) continue
                    const px = map.lngLatToContainer(pos)
                    const { x, y } = getPixelXY(px)
                    if (!Number.isFinite(x) || !Number.isFinite(y)) continue
                    const dx = x - cx
                    const dy = y - cy
                    const dist = Math.hypot(dx, dy)
                    if (dist < minDist) {
                        minDist = dist
                        nearestMarker = m
                        nearestVehicle = m?._originOpts?.vehicleData
                    }
                }
                const threshold = window.innerWidth <= 768 ? 28 : 18
                if (nearestMarker && nearestVehicle && minDist <= threshold) {
                    selectMarker(nearestMarker, nearestVehicle)
                }
            })
        }).catch(e => {
            console.error('地图加载失败:', e);
        });

        return () => {
            if (timeoutRef.current) {
                clearInterval(timeoutRef.current);
                timeoutRef.current = null;
            }
            if (mapRef.current) {
                mapRef.current.destroy();
                mapRef.current = null;
            }
        };
    }, [carList]);



    function startCustomBounceAnimation(marker) {
        const originalPosition = marker.getPosition();
        let startTime = null;
        const duration = 5000;

        function animate(timestamp) {
            if (!startTime) startTime = timestamp;
            const elapsed = timestamp - startTime;
            const progress = Math.min(elapsed / duration, 1);

            const jumpHeight = 5 * Math.sin(progress * Math.PI * 2);
            const newLat = originalPosition.lat + jumpHeight * 0.00001;

            marker.setPosition([originalPosition.lng, newLat]);

            if (progress < 1) {
                requestAnimationFrame(animate);
            } else {
                marker.setPosition(originalPosition);
            }
        }

        requestAnimationFrame(animate);
    }

    function createSelectedTricycleIcon(AMap, status) {
        const iconUrl = `${process.env.PUBLIC_URL + '/logo/downCar.png'}`;
        return new AMap.Icon({
            image: iconUrl,
            size: new AMap.Size(30, 60),
            imageSize: new AMap.Size(30, 60)
        });
    }

    const getCarNumber = () => {
        getCarNum().then(res => {
            if (res?.data?.code === 200) {
                setToday(res.data.data)
            } else if (res?.data?.code == 401) {
                navigate('/login')
            } else {
                message.error(res?.data?.msg)
            }
        })
        getOnlineCars().then(res => {
            if (res?.data?.code === 200) {
                setCarList(res.data.data)
            } else if (res?.data?.code == 401) {
                navigate('/login')
            } else {
                message.error(res?.data?.msg)
            }
        })
        getVehicleDistribution(getLastSevenDaysRange()).then(res => {
            if (res?.data?.code === 200) {
                setWeeklyData(res.data.data)
            } else if (res?.data?.code == 401) {
                navigate('/login')
            } else {
                message.error(res?.data?.msg)
            }
        })
    }

    const setLatitude = (latitude) => {
        if ((latitude + "").includes(".")) {
            let a = (latitude / 100 + "").split(".")[0]
            return a * 1 + extractCoordinateParts(latitude) / 60
        } else {
            return latitude / 100
        }
    }


    function extractCoordinateParts(value) {
        const strValue = String(value);
        const [integerPart, decimalPart] = strValue.split('.');
        const lastTwoDigits = integerPart.slice(-2);
        const formattedLastTwo = lastTwoDigits.padStart(2, '0');
        return `${formattedLastTwo}.${decimalPart}`;
    }


    const setWeeklyData = (data) => {
        const inventoryVehiclesCount = data.map(item => {
            const shortDate = item.statisticsDay.split('-').slice(1).join('-');
            return [shortDate, item.inventoryVehiclesCount];
        });

        const rentedVehiclesCount = data.map(item => {
            const shortDate = item.statisticsDay.split('-').slice(1).join('-');
            return [shortDate, item.rentedVehiclesCount];
        });

        const todayOnlineCount = data.map(item => {
            const shortDate = item.statisticsDay.split('-').slice(1).join('-');
            return [shortDate, item.todayOnlineCount];
        });

        setWeekly({
            inventoryVehiclesCount,
            rentedVehiclesCount,
            todayOnlineCount
        })
    }


    function getLastSevenDaysRange() {
        const currentDate = new Date();
        const sevenDaysAgo = new Date(currentDate);
        sevenDaysAgo.setDate(currentDate.getDate() - 7);

        const formatDate = (date) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };

        return {
            "startDate": formatDate(sevenDaysAgo),
            "endDate": formatDate(currentDate)
        }
    }

    useEffect(() => {
        if (!flag) {
            setFlag(true)
        } else {
            getCarNumber()
        }
    }, [flag])

    useEffect(() => {

    }, [carInfo?.currentVehicleSpeed])

    const logOut = () => {
        localStorage.removeItem('menuKey');
        localStorage.removeItem('token');
        sessionStorage.clear()
        navigate('/login')
    }

    const items = [
        {
            label: <a onClick={() => navigate('/forgot')}>{t('user.reset')}</a>,
            key: '0',
        },
        {
            label: <a onClick={logOut}>{t('user.logOut')}</a>,
            key: '1',
        },
    ];

    const languageItem = [
        {
            label: <a onClick={() => {
                localStorage.setItem("language", "en")
                setLng("en")
                changeLanguage("en")
            }}>{t('english')}</a >,
            key: '0',
        },
        {
            type: 'divider',
        },
        {
            label: <a onClick={() => {
                localStorage.setItem("language", "zh")
                setLng("zn")
                changeLanguage("zh")
            }}>{t('chinese')}</a >,
            key: '1',
        },
    ]


    const onSearch = (value, _e, info) => {
        if (timeoutRef.current) {
            clearInterval(timeoutRef.current);
            timeoutRef.current = null;
        }

        // 先在本地 marker 列表里查找并立即定位——不依赖 API 返回
        if (mapRef.current && value) {
            const matchedMarker = markersRef.current.find(
                marker => marker?._originOpts?.vehicleData?.carNumber == value
            );
            if (matchedMarker) {
                const markerPos = matchedMarker.getPosition();
                mapRef.current.setCenter(markerPos);
                mapRef.current.setZoom(18);

                if (selectedMarkerRef.current && selectedMarkerRef.current !== matchedMarker) {
                    selectedMarkerRef.current.setIcon(createTricycleIcon(amapRef.current, '普通'));
                    const lastAngle = selectedMarkerRef.current.getAngle();
                    selectedMarkerRef.current.setAngle(lastAngle);
                }

                selectedMarkerRef.current = matchedMarker;
                const initialAngle = matchedMarker.getAngle() || 0;
                matchedMarker.setIcon(createSelectedTricycleIcon(amapRef.current, carInfo.status));
                matchedMarker.setAngle(initialAngle);
                startCustomBounceAnimation(matchedMarker);

                setSearchValue(value);
            }
        }

        // API 调用并行执行，返回后再精调坐标和更新详情
        getCarInfo(value).then(res => {
            console.log('=== onSearch getCarInfo response ===');
            console.log('res.data.code:', res?.data?.code);
            console.log('res.data.data:', JSON.stringify(res?.data?.data));
            console.log('longitude:', res?.data?.data?.longitude, 'type:', typeof res?.data?.data?.longitude);
            console.log('latitude:', res?.data?.data?.latitude, 'type:', typeof res?.data?.data?.latitude);
            console.log('mapRef.current exists:', !!mapRef.current);
            if (res?.data?.code === 200) {
                setCarInfo(() => res.data.data)
                highlightSearchedVehicle({ value, longitude: res.data.data?.longitude, latitude: res.data.data?.latitude });
            } else if (res?.data?.code == 401) {
                navigate('/login')
            } else {
                message.error(res?.data?.msg)
            }
        })
        getCarInfo1(value).then(res => {
            if (res?.data?.code === 200) {
                setTenant(res.data?.rows[res.data.total-1])
            } else {
                message.error(res?.data?.msg)
            }
        })
    }

    const calculateDirectionAngle = (fromLng, fromLat, toLng, toLat) => {
        const dx = toLng - fromLng;
        const dy = toLat - fromLat;
        let angle = Math.atan2(dx, dy) * 180 / Math.PI;
        return (angle + 360) % 360;
    };

    const highlightSearchedVehicle = ({ value, longitude, latitude }) => {
        console.log('=== highlightSearchedVehicle called ===');
        console.log('value:', value, 'mapRef.current:', !!mapRef.current);
        console.log('longitude:', longitude, 'latitude:', latitude);
        if (!value || !mapRef.current) {
            console.log('EARLY RETURN: !value || !mapRef.current');
            return;
        }

        // 优先在本地 marker 列表里查找，marker 已在地图上有正确的 GCJ02 坐标，可立即定位
        const matchedMarker = markersRef.current.find(
            marker => marker?._originOpts.vehicleData.carNumber == value
        );

        if (matchedMarker) {
            // 用 marker 当前位置立即居中——零延迟！
            const markerPos = matchedMarker.getPosition();
            mapRef.current.setCenter(markerPos);
            mapRef.current.setZoom(18);
            console.log('INSTANT CENTER via matchedMarker:', markerPos);

            if (selectedMarkerRef.current && selectedMarkerRef.current !== matchedMarker) {
                selectedMarkerRef.current.setIcon(createTricycleIcon(amapRef.current, '普通'));
                const lastAngle = selectedMarkerRef.current.getAngle();
                selectedMarkerRef.current.setAngle(lastAngle);
            }

            selectedMarkerRef.current = matchedMarker;
            const initialAngle = matchedMarker.getAngle() || 0;
            matchedMarker.setIcon(createSelectedTricycleIcon(amapRef.current, carInfo.status));
            matchedMarker.setAngle(initialAngle);

            startCustomBounceAnimation(matchedMarker);

            const animationState = {
                isAnimating: false,
                targetPosition: null,
                startPosition: null,
                startTime: 0,
                animationId: null
            };

            if (matchedMarker.animationState) {
                cancelAnimationFrame(matchedMarker.animationState.animationId);
            }

            matchedMarker.animationState = animationState;

            if (timeoutRef.current) {
                clearInterval(timeoutRef.current);
            }

            timeoutRef.current = setInterval(() => {
                if (!mapRef.current) return;
                getCarInfo(value).then((res) => {
                    if (!mapRef.current) return;
                    if (res?.data?.code === 200) {
                        setCarInfo(res.data.data)
                        let longitude = res.data.data?.longitude
                        let latitude = res.data.data?.latitude
                        if (checkFenceAlarmRef.current) {
                            checkFenceAlarmRef.current(value, longitude, latitude);
                        }
                        if (res.data.data.currentVehicleSpeed != 0) {
                            if (animationState.isAnimating) {
                                cancelAnimationFrame(animationState.animationId);
                            }

                            const targetPos = bd09togcj02(longitude || 0, latitude || 0);
                            const currentPos = matchedMarker.getPosition();

                            const lngDiff = Math.abs(currentPos.getLng() - targetPos[0]);
                            const latDiff = Math.abs(currentPos.getLat() - targetPos[1]);

                            if (lngDiff > 0.00001 || latDiff > 0.00001) {
                                const newAngle = calculateDirectionAngle(
                                    currentPos.getLng(),
                                    currentPos.getLat(),
                                    targetPos[0],
                                    targetPos[1]
                                );

                                animationState.startPosition = currentPos;
                                animationState.targetPosition = targetPos;
                                animationState.startTime = Date.now();
                                animationState.isAnimating = true;

                                matchedMarker.setAngle(newAngle);
                                animateMarker(matchedMarker, animationState);
                            }
                        }
                    } else {
                        message.error(res?.data?.msg)
                    }
                })
            }, 5000)
        } else if (longitude != null && latitude != null && Number(longitude) !== 0 && Number(latitude) !== 0 && Number.isFinite(Number(longitude)) && Number.isFinite(Number(latitude))) {
            // 车辆不在本地 marker 列表（离线等），退而用 API 坐标定位
            const [gcjLng, gcjLat] = bd09togcj02(longitude, latitude);
            console.log('CENTER via API coordinates:', gcjLng, gcjLat);
            mapRef.current.setCenter([gcjLng, gcjLat]);
            mapRef.current.setZoom(18);
        } else {
            console.log('SKIP CENTER: no matchedMarker and coordinates invalid');
        }
    };


    const animateMarker = (marker, state) => {
        const DURATION = 6000;

        const animate = () => {
            if (!state.isAnimating || !mapRef.current) return;

            const elapsed = Date.now() - state.startTime;
            const progress = Math.min(elapsed / DURATION, 1);
            const easeProgress = easeInOutCubic(progress);

            const currentLng = state.startPosition.getLng() +
                (state.targetPosition[0] - state.startPosition.getLng()) * easeProgress;

            const currentLat = state.startPosition.getLat() +
                (state.targetPosition[1] - state.startPosition.getLat()) * easeProgress;

            marker.setPosition([currentLng, currentLat]);

            mapRef.current.setCenter([currentLng, currentLat]);

            if (progress < 1) {
                state.animationId = requestAnimationFrame(animate);
            } else {
                state.isAnimating = false;
            }
        };

        state.animationId = requestAnimationFrame(animate);
    };

    const easeInOutCubic = (t) => {
        return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    };


    const onChange = checked => {
        if (searchValue && searchValue != "") {
            setIsModalOpen(true)
        } else {
            message.error(t('common.selectCar'))
        }
    };

    const handleOk = () => {
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const clearAlarms = () => {
        setAlarmList([]);
        setIsFenceAlarm(false);
        alarmRef.current = {};
    };

    return (
        <div className="mointor">
            <div className="crchivesTop">
                <Search className="search" placeholder={t('input.placeholder')} onSearch={onSearch} enterButton />
                <Dropdown
                        menu={{
                            items: alarmList.map((alarm, index) => ({
                                key: index,
                                label: (
                                    <div className="alarmDropdownItem">
                                        <div className="alarmDropdownMsg">{alarm.message}</div>
                                        <div className="alarmDropdownTime">{alarm.time}</div>
                                    </div>
                                ),
                                onClick: () => {
                                    const matchedMarker = markersRef.current.find(
                                        m => m?._originOpts?.vehicleData?.carNumber === alarm.carNumber
                                    );
                                    if (matchedMarker && selectMarkerRef.current) {
                                        selectMarkerRef.current(matchedMarker, matchedMarker._originOpts.vehicleData);
                                    }
                                }
                            }))
                        }}
                        trigger={['click']}
                        disabled={alarmList.length === 0}
                    >
                        <div className="alarmBar">
                            <div className="alarmIcon">
                                {isFenceAlarm && <AlertOutlined style={{ color: '#ff0000', fontSize: '20px', animation: 'pulse 1s infinite' }} />}
                                <span className="alarmLabel">{t('fence.title')}</span>
                            </div>
                            <div className="alarmContent">
                                {alarmList.length > 0 ? (
                                    <div className="alarmText">{alarmList[0]?.message}</div>
                                ) : (
                                    <div className="noAlarmText">{t('fence.noAlarm')}</div>
                                )}
                            </div>
                            {alarmList.length > 0 && (
                                <Button size="small" onClick={(e) => { e.stopPropagation(); setAlarmList([]); setIsFenceAlarm(false); alarmRef.current = {}; }}>{t('fence.clear')}</Button>
                            )}
                        </div>
                    </Dropdown>
                <div className="tool">
                    <div className="switch">
                        {t('language')} <Dropdown
                            menu={{
                                items: languageItem,
                            }}
                            trigger={['click']}
                        >
                            <GlobalOutlined className="more" onClick={(e) => e.preventDefault()} />
                        </Dropdown>
                    </div>
                    <Card className='userInfo'>
                        <img className='use' src={`https://img2.baidu.com/it/u=844991488,1562672971&fm=253&fmt=auto&app=120&f=JPEG`} alt="头像" />
                        {t('user.name')}
                        <Dropdown
                            menu={{
                                items,
                            }}
                            trigger={['click']}
                        >
                            <CaretDownOutlined className="more" onClick={(e) => e.preventDefault()} />
                        </Dropdown>
                    </Card>
                </div>
            </div>
            <div className="main">
                <div className={`left ${isRightFullscreen ? 'fullscreens' : ''}`}>
                    <Card className='leftTop'>
                        <div id="container" style={{ width: '100%', height: '100%' }} />
                    </Card>
                    <Card className='leftMiddle'>
                        <div className="quantity">
                            <span className="box"><img src={process.env.PUBLIC_URL + '/logo/Vector.png'} alt="car" /></span>
                            <div className="text">
                                <div className="number">{today?.totalCars}</div>
                                <div className="info">{t('carInfo.total')}</div>
                            </div>
                        </div>
                        <div className="quantity">
                            <span className="box"><img src={process.env.PUBLIC_URL + '/logo/Vector.png'} alt="car" /></span>
                            <div className="text">
                                <div className="number">{today?.hiredCars}</div>
                                <div className="info">{t('carInfo.rented')}</div>
                            </div>
                        </div>
                        <div className="quantity">
                            <span className="box"><img src={process.env.PUBLIC_URL + '/logo/Vector.png'} alt="car" /></span>
                            <div className="text">
                                <div className="number">{today?.storageCars}</div>
                                <div className="info">{t('carInfo.inventory')}</div>
                            </div>
                        </div>
                        <div className="quantity">
                            <span className="box"><img src={process.env.PUBLIC_URL + '/logo/Vector.png'} alt="car" /></span>
                            <div className="text">
                                <div className="number">{today?.onlineCars}</div>
                                <div className="info">{t('carInfo.onLine')}</div>
                            </div>
                        </div>
                    </Card>
                    <Card className='leftButtom'>
                        <div className="butLeft">
                            <div className="title"><span className="piece"></span>{t('carInfo.title')}</div>
                            <Circular data={today} />
                        </div>
                        <div className="line"></div>
                        <div className="butRight">
                            <Line data={weekly} />
                        </div>
                    </Card>
                </div>
                <Card className={`right ${!isRightFullscreen ? '' : 'fullscreen'}`}>
                    <Card className='rightFirst'>
                        <div className="title" style={{position:"relative"}}>
                            <span className="piece"></span>{t('rightInfo.driverTitle')} {isRightFullscreen && (
                                <Button
                                    className="exit-fullscreen-btn"
                                    icon={<LeftOutlined />}
                                    style={{ position: "absolute", right: 0}}
                                    onClick={toggleRightFullscreen}
                                >
                                    {t('exit')}
                                </Button>)}</div>
                        <div className="imgs">
                            <div className="picture">
                                <img className='use' src={carInfo?.photo ? process.env.NODE_ENV === "development" ? `http://58.221.151.226:8299${carInfo?.photo}` : `http://183.249.69.67:8000${carInfo?.photo}` : `https://img2.baidu.com/it/u=844991488,1562672971&fm=253&fmt=auto&app=120&f=JPEG`} alt="头像" />
                            </div>
                            <div className="text">{tenant?.hirer || t('common.name')}</div>
                        </div>
                        <div className={`textInfo ${i18n?.language == "en" ? "enRight" : ""}`}>
                            <div className="info">
                                <div className="key">{t('rightInfo.number')}：</div>
                                <div className="value">{tenant?.operatorId || "-"}</div>
                            </div>
                            <div className="info">
                                <div className="key">{t('rightInfo.telephones')}：</div>
                                <div className="value">{tenant?.phonenumber || "-"}</div>
                            </div>
                        </div>
                    </Card>
                    <div className="line"></div>
                    <Card className='carInfo'>
                        <div className="title"><span className="piece"></span>{t('varehicleInformation.title')}</div>
                        <div className="info">
                            <div className="text">
                                <div className="key">{t('varehicleInformation.model')}:</div>
                                <div className="value">{carInfo?.carModel || ""}</div>
                            </div>
                            <div className="text">
                                <div className="key">{t('varehicleInformation.speed')}:</div>
                                <div className="value">{carInfo?.currentVehicleSpeed || "0"} km/h</div>
                            </div>
                            <div className="text">
                                <div className="key">{t('varehicleInformation.battery')}:</div>
                                <div className="value"><span className={`iconfont icon-dianliang`} />{carInfo?.remainingPower || "0"} %</div>
                            </div>
                            <div className="text">
                                <div className="key">{t('varehicleInformation.mileage')}:</div>
                                <div className="value">{carInfo?.totalMileage || "0"} km</div>
                            </div>
                            <div className="text">
                                <div className="key">{t('varehicleInformation.today')}:</div>
                                <div className="value">{(() => {
                                    const total = Number(carInfo?.totalMileage);
                                    const yesterday = Number(carInfo?.yesterdayMileage);
                                    if (Number.isFinite(total) && Number.isFinite(yesterday)) {
                                        return Math.max(total - yesterday, 0);
                                    }
                                    return "0";
                                })()} km</div>
                            </div>
                        </div>
                    </Card>
                    <div className="line"></div>
                    <Card className='carStatus'>
                        <div className="title"><span className="piece"></span>{t('health.title')}</div>
                        <div className="info">
                            <div className={`text ${carInfo?.motorStatus == 1 ? "treat" : carInfo?.motorStatus == 2 ? "error" : ""}`}>
                                <div className="key"><span className="round"><img src={process.env.PUBLIC_URL + '/logo/dianji.png'} alt="电机" /></span>{t('health.motor')}:</div>
                                <div className="value">{carInfo?.motorStatus == 0 ? t('status.normal') : carInfo?.motorStatus == 1 ? t('status.pending') : carInfo?.motorStatus == 2 ? t('status.abnormal') : "-"}</div>
                            </div>
                            <div className={`text ${carInfo?.batteryStatus == 1 ? "treat" : carInfo?.motorStatus == 2 ? "error" : ""}`}>
                                <div className="key"><span className="round"><img src={process.env.PUBLIC_URL + '/logo/dainchi.png'} alt="电池" /></span>{t('health.battery')}:</div>
                                <div className="value">{carInfo?.batteryStatus == 0 ? t('status.normal') : carInfo?.batteryStatus == 1 ? t('status.pending') : carInfo?.batteryStatus == 2 ? t('status.abnormal') : "-"}</div>
                            </div>
                            <div className={`text ${carInfo?.chargingStatus == 1 ? "treat" : carInfo?.motorStatus == 2 ? "error" : ""}`}>
                                <div className="key"><span className="round"><img src={process.env.PUBLIC_URL + '/logo/chongdian.png'} alt="充电" /></span>{t('health.recuperate')}:</div>
                                <div className="value">{carInfo?.chargingStatus == 0 ? t('status.normal') : carInfo?.chargingStatus == 1 ? t('status.charging') : carInfo?.chargingStatus == 2 ? t('status.abnormal') : "-"}</div>
                            </div>
                        </div>
                    </Card>
                    <div className="line"></div>
                    <Card className='flag'>
                        <div className="title">
                            <div className="hade">
                                <span className="piece"></span>{t('health.flagTitle')}
                            </div>
                            <div className="switch">
                                {t('health.flag')}
                                <Switch onChange={onChange} value={switchValue} />
                            </div>
                        </div>
                        <Modal
                            title={t('health.flagTitle')}
                            closable={{ 'aria-label': 'Custom Close Button' }}
                            open={isModalOpen}
                            onOk={handleOk}
                            cancelText={t("cancel")}
                            okText={t("onOk")}
                            onCancel={handleCancel}
                        >
                            <div>{t("batteryDischarge")}：<Switch onChange={onChange} /></div>
                            <div>{t("pilot")}：<Switch onChange={onChange} /></div>
                        </Modal>
                    </Card>
                </Card>
            </div>
        </div>
    )
}

export { Mointor }
